import { ComponentStylesWithFns } from '../../theme/styles.helpers';

type StatusDotStates = { color: string };

export const StatusDotStyles: ComponentStylesWithFns<StatusDotStates> = {
  dot: ({ color }) => [
    {
      width: '16px',
      height: '16px',
      borderRadius: '8px',
      flexShrink: 0,
    },
    { backgroundColor: color },
  ],
};
